var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var breathe = require('../utils/breathe'); //Returns the GPS data as a string


function getGPGS5Data(_x) {
  return _getGPGS5Data.apply(this, arguments);
} // Creates accelerometer GPX content for Virb


function _getGPGS5Data() {
  _getGPGS5Data = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var frameRate, inner, device, key, stream, name, units, sticky, i, s, time, ele, geoidHeight, partial, firstDate, firstTime, fakeFirst, description;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            inner = '';
            device = '';
            if (data['frames/second'] != null) frameRate = "".concat(Math.round(data['frames/second']), " fps");
            _context2.t0 = _regeneratorRuntime.keys(data);

          case 4:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 26;
              break;
            }

            key = _context2.t1.value;
            if (data[key]['device name'] != null) device = data[key]['device name'];

            if (!data[key].streams) {
              _context2.next = 24;
              break;
            }

            _context2.t2 = _regeneratorRuntime.keys(data[key].streams);

          case 9:
            if ((_context2.t3 = _context2.t2()).done) {
              _context2.next = 24;
              break;
            }

            stream = _context2.t3.value;
            _context2.next = 13;
            return breathe();

          case 13:
            if (!(stream === 'GPS5' && data[key].streams.GPS5.samples)) {
              _context2.next = 22;
              break;
            }

            name = void 0;
            if (data[key].streams.GPS5.name != null) name = data[key].streams.GPS5.name;
            units = void 0;
            if (data[key].streams.GPS5.units != null) units = "[".concat(data[key].streams.GPS5.units.toString(), "]");
            sticky = {}; //Loop all the samples

            for (i = 0; i < data[key].streams.GPS5.samples.length; i++) {
              s = data[key].streams.GPS5.samples[i]; //Check that at least we have the valid values

              if (s.value && s.value.length > 1) {
                //Update and remember sticky data
                if (s.sticky) sticky = _objectSpread(_objectSpread({}, sticky), s.sticky);
                time = '';
                ele = '';
                geoidHeight = ''; //Use sticky info

                if (sticky.geoidHeight != null) geoidHeight = "\n                <geoidheight>".concat(sticky.geoidHeight, "</geoidheight>"); //Set elevation if present

                if (s.value.length > 1) ele = "\n                <ele>".concat(s.value[2], "</ele>"); //Set time if present

                if (s.date != null) {
                  if (typeof s.date != 'object') s.date = new Date(s.date);

                  try {
                    time = "\n                <time>".concat(s.date.toISOString().replace(/\.(\d{3})Z$/, 'Z'), "</time>");
                  } catch (e) {
                    time = "\n                <time>".concat(s.date, "</time>");
                  }
                } //Create sample string


                partial = "\n            <trkpt lat=\"".concat(s.value[0], "\" lon=\"").concat(s.value[1], "\">\n                ").concat((ele + time + geoidHeight).trim(), "\n            </trkpt>");

                if (i === 0 && s.cts > 0) {
                  // If first sample missing, fake it for better sync
                  firstDate = void 0;

                  try {
                    firstDate = new Date(s.date.getTime() - s.cts).toISOString().replace(/\.(\d{3})Z$/, 'Z');
                  } catch (e) {
                    firstDate = new Date(s.date - s.cts).toISOString().replace(/\.(\d{3})Z$/, 'Z');
                  }

                  firstTime = "\n                <time>".concat(firstDate, "</time>");
                  fakeFirst = "\n                <trkpt lat=\"".concat(s.value[0], "\" lon=\"").concat(s.value[1], "\">\n                    ").concat((ele + firstTime + geoidHeight).trim(), "\n                </trkpt>");
                  inner += "".concat(fakeFirst);
                } //Add it to samples


                inner += "".concat(partial);
              }
            } //Create description of file/stream


            description = [frameRate, name, units].filter(function (e) {
              return e != null;
            }).join(' - ');
            return _context2.abrupt("return", {
              inner: inner,
              description: description,
              device: device
            });

          case 22:
            _context2.next = 9;
            break;

          case 24:
            _context2.next = 4;
            break;

          case 26:
            return _context2.abrupt("return", {
              inner: inner,
              description: frameRate || '',
              device: device
            });

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getGPGS5Data.apply(this, arguments);
}

function getACCLData(_x2) {
  return _getACCLData.apply(this, arguments);
} //Converts the processed data to GPX


function _getACCLData() {
  _getACCLData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
    var frameRate, inner, device, key, stream, name, units, i, s, time, acceleration, partial, firstDate, firstTime, firstAccel, fakeFirst, description;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            inner = '';
            device = '';
            if (data['frames/second'] != null) frameRate = "".concat(Math.round(data['frames/second']), " fps");
            _context3.t0 = _regeneratorRuntime.keys(data);

          case 4:
            if ((_context3.t1 = _context3.t0()).done) {
              _context3.next = 24;
              break;
            }

            key = _context3.t1.value;
            if (data[key]['device name'] != null) device = data[key]['device name'];

            if (!data[key].streams) {
              _context3.next = 22;
              break;
            }

            _context3.t2 = _regeneratorRuntime.keys(data[key].streams);

          case 9:
            if ((_context3.t3 = _context3.t2()).done) {
              _context3.next = 22;
              break;
            }

            stream = _context3.t3.value;
            _context3.next = 13;
            return breathe();

          case 13:
            if (!(stream === 'ACCL' && data[key].streams.ACCL.samples)) {
              _context3.next = 20;
              break;
            }

            name = void 0;
            if (data[key].streams.ACCL.name != null) name = data[key].streams.ACCL.name;
            units = "[g]"; //Loop all the samples

            for (i = 0; i < data[key].streams.ACCL.samples.length; i++) {
              s = data[key].streams.ACCL.samples[i]; //Check that at least we have the valid values

              if (s.value && s.value.length) {
                time = '';
                acceleration = ''; //Set time if present

                if (s.date != null) {
                  if (typeof s.date != 'object') s.date = new Date(s.date);

                  try {
                    time = "\n                  <time>".concat(s.date.toISOString(), "</time>");
                  } catch (e) {
                    time = "\n                  <time>".concat(s.date, "</time>");
                  }
                }

                acceleration = "\n                  <extensions>\n                    <gpxacc:AccelerationExtension>\n                      <gpxacc:accel offset=\"0\" x=\"".concat(s.value[1] / 9.80665, "\" y=\"").concat(s.value[2] / 9.80665, "\" z=\"").concat(s.value[0] / 9.80665, "\"/>\n                      <gpxacc:accel offset=\"0\" x=\"").concat(s.value[1] / 9.80665, "\" y=\"").concat(s.value[2] / 9.80665, "\" z=\"").concat(s.value[0] / 9.80665, "\"/>\n                    </gpxacc:AccelerationExtension>\n                  </extensions>"); //Create sample string

                partial = "\n              <trkpt lat=\"0\" lon=\"0\">\n                  ".concat((time + acceleration).trim(), "\n              </trkpt>");

                if (i === 0 && s.cts > 0) {
                  // If first sample missing, fake it for better sync
                  firstDate = void 0;

                  try {
                    firstDate = new Date(s.date.getTime() - s.cts).toISOString();
                  } catch (e) {
                    firstDate = new Date(s.date - s.cts).toISOString();
                  }

                  firstTime = "\n                <time>".concat(firstDate, "</time>");
                  firstAccel = "\n                <extensions>\n                  <gpxacc:AccelerationExtension>\n                    <gpxacc:accel offset=\"0\" x=\"0\" y=\"0\" z=\"0\"/>\n                    <gpxacc:accel offset=\"0\" x=\"0\" y=\"0\" z=\"0\"/>\n                  </gpxacc:AccelerationExtension>\n                </extensions>";
                  fakeFirst = "\n                <trkpt lat=\"0\" lon=\"0\">\n                  ".concat((firstTime + firstAccel).trim(), "\n              </trkpt>");
                  inner += "".concat(fakeFirst);
                } //Add it to samples


                inner += "".concat(partial);
              }
            } //Create description of file/stream


            description = [frameRate, name, units].filter(function (e) {
              return e != null;
            }).join(' - ');
            return _context3.abrupt("return", {
              inner: inner,
              description: description,
              device: device
            });

          case 20:
            _context3.next = 9;
            break;

          case 22:
            _context3.next = 4;
            break;

          case 24:
            return _context3.abrupt("return", {
              inner: inner,
              description: frameRate || '',
              device: device
            });

          case 25:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getACCLData.apply(this, arguments);
}

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
    var name, stream, converted, string;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = _ref.name, stream = _ref.stream;

            if (!(stream[0] === 'GPS5')) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return getGPGS5Data(data);

          case 4:
            converted = _context.sent;
            _context.next = 14;
            break;

          case 7:
            if (!(stream[0] === 'ACCL')) {
              _context.next = 13;
              break;
            }

            _context.next = 10;
            return getACCLData(data);

          case 10:
            converted = _context.sent;
            _context.next = 14;
            break;

          case 13:
            return _context.abrupt("return", undefined);

          case 14:
            if (converted) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", undefined);

          case 16:
            string = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<gpx xmlns=\"http://www.topografix.com/GPX/1/1\"\n    xmlns:gpxacc=\"http://www.garmin.com/xmlschemas/AccelerationExtension/v1\"\n    version=\"1.1\"\n    creator=\"https://github.com/juanirache/gopro-telemetry\">\n    <trk>\n        <name>".concat(name, "</name>\n        <desc>").concat(converted.description, "</desc>\n        <src>").concat(converted.device, "</src>\n        <trkseg>\n            ").concat(converted.inner.trim(), "\n        </trkseg>\n  </trk>\n</gpx>");
            return _context.abrupt("return", string);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();